import * as React from 'react';
import { TButtonSize } from '@cian/ui-kit/button/types';

import { BuilderChatButtonContainer } from '../BuilderChatButton';
import { INewbuilding } from '../../types/newbuilding';

interface IMessageButtonContainerProps {
  newbuilding: INewbuilding;
  buttonSize?: TButtonSize;
  isPromoSnippet?: boolean;
}

/**
 * Развилка для кнопок, открывающих разные виды чатов.
 */
export const MessageButtonContainer: React.FC<IMessageButtonContainerProps> = ({
  newbuilding,
  buttonSize,
  isPromoSnippet,
}) => {
  return (
    <BuilderChatButtonContainer newbuilding={newbuilding} buttonSize={buttonSize} isPromoSnippet={isPromoSnippet} />
  );
};
